import React, { memo } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import _isEqual from 'lodash/isEqual';

import StatusBadge from 'components/StatusBadge';
import FraudScore from 'components/FraudScore';
import visa_logo from 'assets/icons/visa_blue.svg';

import { disputeDetails as TEXT } from 'locales/en/dispute';
import { UNDER_REVIEW } from '../helpers';

const TITLES = [
  TEXT.date,
  TEXT.customer_name,
  TEXT.payment_method,
  TEXT.risk_score,
];

const Summary = ({ dispute }) => {
  const {
    created_at,
    amountToDisplay,
    status,
    defense_submitted,
    transaction,
  } = dispute;
  const { shopper_name, risk_score, last4 } = transaction;

  return (
    <div className="p-0 mb-8 card">
      <div className="p-6 border-b border-javelin-gray-border lg:p-12">
        <p className="mb-3 text-xs text-javelin-gray-light">{TEXT.payment}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-3xl font-bold">{amountToDisplay}</span>
            <StatusBadge status={(defense_submitted && status === UNDER_REVIEW) ? 'evidence_submitted' : status} />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-2 p-6 lg:w-10/12 lg:p-12">
        {TITLES.map((title) => (
          <div key={title} className="flex" data-testid={title}>
            <span className="text-xs text-javelin-gray-light">{title}</span>
          </div>
        ))}
        <span className="text-sm text-javelin-gray-dark">
          {format(new Date(created_at), 'dd MMM, H:m')}
        </span>
        <span className="text-sm text-javelin-gray-dark">
          {shopper_name || '-'}
        </span>
        <span>
          <div className="flex items-center text-sm text-javelin-gray-dark">
            <img
              className="inline w-6 ml-0 mr-1 overflow-visible rounded-sm"
              src={visa_logo}
              alt={`visa ending in ${last4}`}
            />
            <span className="h-full">ending in {last4}</span>
          </div>
        </span>
        <FraudScore value={risk_score} />
      </div>
    </div>
  );
};

Summary.propTypes = {
  dispute: PropTypes.shape({})
};
Summary.defaultProps = {
  dispute: {},
};

const areEqual = (prevProps, nextProps) => {
  return _isEqual(prevProps.dispute, nextProps.dispute);
};

export default memo(Summary, areEqual);
